import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { _HttpClient, SettingsService } from '@delon/theme';
import { NzSelectComponent } from 'ng-zorro-antd/select';

import { CustomerAddConfigService } from '../../inline-add-panel/customer-add-config.service';
import { InlineAddPanelComponent } from '../../inline-add-panel/inline-add-panel.component';
import { SelectBaseComponent } from '../select-base';
import { SelectInstantBaseComponent } from '../selectInstant-base';
import { SelectInstantBaseNewComponent } from '../selectInstant-base-new';

@Component({
  selector: 'app-ar-cate-select',
  templateUrl: './ar-cate-select.component.html',
  styles: [
    `
      ::ng-deep .ant-select-item-option-content .special-option {
        text-align: center !important;
      }

      .ar-cate-select-container {
        position: relative;
        width: 100%;
      }

      ::ng-deep .add-new-button {
        color: #000000 !important;
        font-weight: 500 !important;
        width: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 2px !important;
        background-color: transparent !important;
        border: none !important;
      }

      ::ng-deep .add-new-button .anticon {
        color: #000000 !important;
      }

      ::ng-deep
        .dropdownSelect:not(:has(.ant-select-item-option-active))
        .ant-select-item-option:nth-child(2):not(
          .ant-select-item-option-active
        ):not(.ant-select-item-option-selected):not(:hover) {
        background-color: #ffc000;
      }
      ::ng-deep
        .dropdownSelect
        .ant-select-item-option:first-child:last-child:not(
          .ant-select-item-option-active
        ):not(.ant-select-item-option-selected):not(:hover) {
        background-color: #ffc000;
      }
    `
  ],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomerCategorySelectComponent),
      multi: true
    }
  ]
})
export class CustomerCategorySelectComponent
  extends SelectInstantBaseNewComponent
  implements OnInit, AfterViewInit
{
  @ViewChild('selector') nzSelectComponent!: NzSelectComponent;

  @Input() tabindex: string | null = null;

  NotShowInReport: boolean = false;
  categoryConfig: any;
  inlineDefaults: any = null;
  // Store instant data separately to preserve it when dropdown closes

  constructor(
    http: _HttpClient,
    router: Router,
    cdr: ChangeDetectorRef,
    private resueTabService: ReuseTabService,
    private customerAddConfigService: CustomerAddConfigService,
    private settingsService: SettingsService
  ) {
    super(http, cdr, router);
  }

  ngOnInit(): void {
    this.checkAddNewOptionInReportAccess();
    this.categoryConfig =
      this.customerAddConfigService.getCustomerCategoryConfig();

    // Listen to search form changes to store instant data
    this.searchForm.controls.keyword.valueChanges.subscribe(value => {
      if (value) {
        const trimmedValue = value.trim();
        this.storedInstantData = trimmedValue;
        // Also store in pendingInstantData for Add New (handled by base class)
        this.pendingInstantData = trimmedValue;
      }
    });

    // Ensure the correct item is active whenever the list updates while open
    this.onListFilled.subscribe(() => {
      if ((this.nzSelectComponent as any)?.nzOpen) {
        this.ensureFirstItemActivatedAndFocused();
      }
    });
  }

  //!default filter
  // getUrl(searchValue: string): string {
  //   let url = `api/customercategories/query?$top=50&$skip=0&$orderby=code asc`;
  //   if (searchValue) {
  //     const searchStr = searchValue.replaceAll("'", "''");
  //     url = `${url}&$filter=(contains(code, '${encodeURIComponent(
  //       searchStr
  //     )}') or contains(name,'${encodeURIComponent(searchStr)}'))`;
  //   }

  //   return url;
  // }

  //with uds
  getUrl(searchValue: string): string {
    let filter = '';
    if (searchValue && searchValue.trim()) {
      // Check if this is a valueField match request (indicated by special prefix)
      const isValueFieldMatch = searchValue.startsWith(SelectBaseComponent.VALUEFIELD_MATCH_PREFIX);
      const actualSearchValue = isValueFieldMatch
        ? searchValue.substring(SelectBaseComponent.VALUEFIELD_MATCH_PREFIX.length)
        : searchValue;

      const searchStr = actualSearchValue.replaceAll("'", "''");

      // Check if searchValue can be converted to int (ID)
      const searchValueNum = parseInt(actualSearchValue, 10);
      const isNumericId =
        !isNaN(searchValueNum) &&
        searchValueNum.toString() === actualSearchValue.trim();

      if (isValueFieldMatch) {
        // ValueField match: use eq operator for precise matching based on valueField
        // Ignore prerequisite conditions when matching by valueField
        // This ensures we can find records even if they don't meet other conditions
        if (this.valueField === 'id') {
          // Match by ID exactly
          filter = `(id eq ${isNumericId ? searchValueNum : actualSearchValue})`;
        } else {
          // Match by the specified valueField exactly (code, name, etc.)
          // Use the valueField if set, otherwise default to 'code'
          const fieldName = this.valueField || 'code';
          filter = `(${fieldName} eq '${encodeURIComponent(searchStr)}')`;
        }
      } else {
        // Partial match: use contains for search behavior
        if (isNumericId) {
          // Include ID matching: (Id eq <id>) or (code/name contains search)
          filter = `((id eq ${searchValueNum}) or (contains(code, '${searchStr}') or contains(name, '${searchStr}')))`;
        } else {
          // Original behavior: only search by code/name
          filter = `(contains(code, '${searchStr}') or contains(name, '${searchStr}'))`;
        }
      }
    }
    let url = `api/customercategories/query?$top=50&$skip=0&$orderby=code asc`;
    if (filter) {
      url += `&$filter=${filter}`;
    }
    return url;
  }

  // set the location want to navigate
  jump(): string {
    return '/ar/category';
  }

  // set the param
  queryParam(): String {
    return 'CustomerCategoryCode';
  }

  checkAddNewOptionInReportAccess(): boolean {
    let curUrl = this.resueTabService.curUrl.toLowerCase();

    if (curUrl.includes('report')) {
      this.NotShowInReport = true;
    } else {
      this.NotShowInReport = false;
    }

    return this.NotShowInReport;
  }
  ngAfterViewInit(): void {
    if (this.tabindex && this.selector) {
      const selectorEl = this.selector.originElement.nativeElement;
      const searchInput = selectorEl.querySelector('input');

      if (searchInput) {
        searchInput.setAttribute('tabindex', this.tabindex?.toString() || '0');

        // Listen to input events directly
        searchInput.addEventListener('input', (event: any) => {
          if (event.target.value) {
            const trimmedValue = event.target.value.trim();
            this.storedInstantData = trimmedValue;
            // Also store in pendingInstantData for Add New (handled by base class)
            this.pendingInstantData = trimmedValue;
          }
        });
      }
    }
  }

  // // Override search method to store instant data
  // override search(value: string, maxLength: number = 10): void {
  //   // Store the instant data before calling parent method
  //   this.storedInstantData = value.trim();
  //   super.search(value, maxLength);
  // }

  // // Override setKeyword method to store instant data
  // override setKeyword(value: string, maxLength: number = 10): void {
  //   // Store the instant data before calling parent method
  //   this.storedInstantData = value.trim();
  //   super.setKeyword(value, maxLength);
  // }

  // Override the addNew method to show inline panel instead of navigation
  override addNew(): void {
    // Use pendingInstantData which was captured synchronously in base class onAddNewClick
    // This ensures we have the data even if storedInstantData was cleared
    const instantDataToUse = this.pendingInstantData || this.storedInstantData;

    // If we still don't have data, try to capture it
    if (!instantDataToUse) {
      this.captureCurrentSearchValue();
      const currentSearchValue = this.getCurrentSearchValue();
      if (currentSearchValue) {
        this.pendingInstantData = currentSearchValue;
      }
    }

    // Final fallback - use whatever we have
    const finalInstantData =
      this.pendingInstantData || this.storedInstantData || '';

    // Load options and defaults first, then show panel
    Promise.all([this.loadSelectOptions(), this.fetchInlineDefaults()]).then(
      () => {
        // Merge instant data into initialData as fallback
        if (finalInstantData) {
          this.inlineDefaults = {
            ...this.inlineDefaults,
            code: finalInstantData
          };
        }

        this.showInlineAddPanel = true;
        // Force change detection to ensure the panel is rendered
        this.cdr.detectChanges();

        // Retry mechanism to ensure changeInstantData is called after form is ready
        const trySetInstantData = (retries: number = 10) => {
          if (!finalInstantData) return;

          if (this.inlineAddPanel && this.inlineAddPanel.formGroup) {
            const instantFieldName =
              this.categoryConfig?.fields?.find((f: any) => f.isInstantData)
                ?.name || 'code';
            const control = this.inlineAddPanel.formGroup.get(instantFieldName);
            if (control) {
              this.inlineAddPanel.changeInstantData(finalInstantData);
              return;
            }
          }

          if (retries > 0) {
            setTimeout(() => trySetInstantData(retries - 1), 50);
          }
        };

        // Try immediately and with retries
        setTimeout(() => {
          if (this.inlineAddPanel && finalInstantData) {
            this.inlineAddPanel.changeInstantData(finalInstantData);
          }
          trySetInstantData();
        }, 0);

        if (this.nzSelectComponent) {
          this.nzSelectComponent.setOpenState(false);
        }
      }
    );
  }

  onCategoryCreated(event: { item: any; selectionConfig?: any }): void {
    if (event.item && event.selectionConfig) {
      // Create the category object in the expected format
      const category = {
        id: event.item[event.selectionConfig.valueField],
        code: event.item.code,
        name: event.item[event.selectionConfig.labelField],
        description: event.item.description
      };

      // Add the new category to the list and select it
      this.list.unshift(category);

      // Close the inline panel first
      this.showInlineAddPanel = false;

      // Set the category object in the form control to trigger category.valueChanges
      this.value = category.id;
      this.selected = category.id;

      // Set the category object directly in the form control
      this.onChange(category);
      this.writeValue(category);

      // Clear stored instant data after successful creation
      this.clearStoredInstantData();

      // Force change detection
      this.cdr.detectChanges();
    }
  }

  onCategoryCancelled(): void {
    this.showInlineAddPanel = false;
    this.clearStoredInstantData();
  }

  onCategoryMoreDetails(): void {
    // Navigate to category details page with all the current form data
    const formData = this.inlineAddPanel?.formGroup?.value;
    if (formData) {
      // Create query params with all form fields
      const queryParams: any = {
        autoPopulate: 1
      };

      // Add all form fields to query params
      if (formData.code) queryParams.CustomerCategoryCode = formData.code;
      if (formData.name) queryParams.Name = formData.name;
      if (formData.description) queryParams.Description = formData.description;
      if (formData.isDefault !== undefined)
        queryParams.IsDefault = formData.isDefault;

      queryParams.autoPopulate = 1;

      this.router.navigate(['/ar/category'], {
        queryParams: queryParams
      });
    } else {
      this.router.navigate(['/ar/category'], {
        queryParams: {
          autoPopulate: 1
        }
      });
    }
    this.showInlineAddPanel = false;
    this.clearStoredInstantData();
  }

  onFieldChange(event: { fieldName: string; value: any }): void {
    // Handle field changes - auto-code component will handle code generation
  }

  private loadSelectOptions(): Promise<void> {
    // For categories, we don't need to load additional options like customers do
    return Promise.resolve();
  }

  private fetchInlineDefaults(): Promise<void> {
    // Call server to get defaults similar to category/detail new()
    return new Promise(resolve => {
      this.http.get('api/customercategories/new').subscribe({
        next: (data: any) => {
          const defaults: any = {};
          if (data?.code) defaults.code = data.code;
          if (data?.name) defaults.name = data.name;
          if (data?.description) defaults.description = data.description;

          this.inlineDefaults = defaults;
          resolve();
        },
        error: () => {
          this.inlineDefaults = null;
          resolve();
        }
      });
    });
  }

  override async writeValue(value: any) {
    // Extract ID if value is an object (e.g., from API response)
    let idValue = value;
    if (value && typeof value === 'object' && this.valueField) {
      idValue = value[this.valueField] || value.id;
    }

    this.value = idValue;

    // If use selected item as value
    if (this.value) {
      if (!this.valueField) {
        this.ensureItemPresentList(value);
        this.selected = value;
      } else {
        // When valueField is set, we need to fetch the list to find the matching item
        // Use valueField match to find the record that exactly matches the valueField (ID or Code)
        // Prefix keyword with special marker to indicate valueField match (ignores prerequisite conditions)
        let keyword = `${SelectBaseComponent.VALUEFIELD_MATCH_PREFIX}${idValue}`;
        await this.fetchData(keyword);
        this.selected = this.list.find(x => x[this.valueField] == idValue);
      }
    } else {
      this.selected = null;
      //this.list = [];
    }
  }
}
